module.exports = __webpack_public_path__ + "static/digital-paint-board-e38ef6fa52ea978c4392f537b24ec958.png";